import script from "./TagsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsView.vue?vue&type=script&setup=true&lang=js"

import "./TagsView.vue?vue&type=style&index=0&id=7b19b916&lang=scss&scoped=true"
import "./TagsView.vue?vue&type=style&index=1&id=7b19b916&lang=scss"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b19b916"]])

export default __exports__